import './home.css';
import HOCModal from '../components/HOCModal';
import Slider from '../components/slider/slider';



const Home = (props) => {

    return (
        <div className="homePage">
            <div className='homeHeader'>
                <div className='sliderHeader'>
                    <Slider />
                </div>
                
            </div>

            <div className='ourFavourites'>
                <h1 className='ourFavHeader'>Our Favourites</h1>
                <div className='ourFavSlice'>
                    {props.allCookies?.slice(0, 3).map((data, index) => {
                        return (
                            <HOCModal data={data} index={index} key={index} />
                        )
                    })}
                </div>
            </div>

            {/* 
            <div className="carouselMain">
                {props.cookies?.slice(0, 3).map((cookie, index) => {
                    return <div key={index}>
                        <CookieModal cookie={cookie} index={index} />
                    </div>
                })}
            </div>  */}
        </div>
    )
}

export default Home;